import React, { Component } from "react";
import PropTypes from 'prop-types';
import config from 'config';
import Amplify, { Storage } from 'aws-amplify';
import md5 from 'md5';
import { connect } from 'react-redux';
import { compose } from "recompose";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormLabel from '@material-ui/core/FormLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';
import DoneIcon from '@material-ui/icons/Done';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import CardActions from '@material-ui/core/CardActions';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import Modal from '@material-ui/core/Modal';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import AddIcon from '@material-ui/icons/Add';
import EditIcon from '@material-ui/icons/Edit';
import FolderIcon from '@material-ui/icons/Folder';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';

// core components
import Card from "../../modules/Card/Card.jsx";
import CardHeader from "../../modules/Card/CardHeader.jsx";
import CardAvatar from "../../modules/Card/CardAvatar.jsx";
import CardBody from "../../modules/Card/CardBody.jsx";
import CardFooter from "../../modules/Card/CardFooter.jsx";
import owl from "../../images/owl-2.png";
import certifiedAA from "../../images/azure-administrator-associate.png";
import certifiedAIA from "../../images/azure-ai-engineer.png";
import certifiedDEA from "../../images/azure-data-engineer-associate.png";
import certifiedDSA from "../../images/azure-data-scientist-associate.png";
import certifiedDA from "../../images/azure-developer-associate.png";
import certifiedDEE from "../../images/azure-devops-engineer-expert.png";
import certifiedF from "../../images/azure-fundamentals.png";
import certifiedSEA from "../../images/azure-security-engineer-associate.png";
import certifiedSAE from "../../images/azure-solutions-architect-expert.png";
import { userActions, departmentActions } from '../../_actions';
import { checkValue } from '../../_helpers';
import Role1 from '../Game/Role1';
import './App.css';
import TagsComponent from '../Common/TagsComponent';
import Progress from '../Common/Progress';
import CertFormComponent from './CertFormComponent';
import DataTableContainer from './DataTableContainer';

Amplify.configure({
    Auth: {
        identityPoolId: config.cognitoIdentityPoolId, //REQUIRED - Amazon Cognito Identity Pool ID
        region: config.awsRegion, // REQUIRED - Amazon Cognito Region
    }
});

Storage.configure({
    bucket: config.s3BucketName, //REQUIRED -  Amazon S3 bucket,
    region: config.awsRegion,
});

const styles = theme => ({
    componentBody: {
        overflowX: 'hidden',
        overflowY: 'scroll',
        left: '70vh',
    },
    formControl: {
        margin: theme.spacing.unit * 3,
    },
    cardTitleWhite: {
        color: "#FFFFFF",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "600",
        fontSize: "2em",
        fontFamily: "'Microsoft JhengHei', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none"
    },
    cardCategoryWhite: {
        color: "rgba(255,255,255,.62)",
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        marginBottom: "0",
        fontFamily: "'Microsoft JhengHei', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    },
    cardCategory: {
        color: "#999999",
        margin: "0",
        fontSize: "2em",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0",
        fontFamily: "'Microsoft JhengHei', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        textAlign: 'left',
        width: '100vh'
    },
    cardTitle: {
        color: "#3C4858",
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "1000",
        fontSize: "18px",
        fontFamily: "'Microsoft JhengHei', 'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
            color: "#777",
            fontWeight: "400",
            lineHeight: "1"
        }
    },
    button: {
        margin: theme.spacing.unit,
        width: '25%',
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: 20,
    },
    profileEditPage:
        theme.palette.type === 'light'
            ? {

            }
            : {
                background: '#424242'
            },
    card: {
        width: 'fit-content',
        backgroundColor: 'rgba(255,255,255,0.7)'
    },
    content: {
        display: 'flex',
        flexWrap: 'wrap',
    }
});

class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            departmentsData: [],

            UserId: '',
            UserAd: '',
            Username: '',
            Email: '',
            DepartmentId: '',
            JobTitle: '',
            FirstName: '',
            LastName: '',
            F: false,
            AA: false,
            SEA: false,
            SAE: false,
            AIA: false,
            DEA: false,
            DSA: false,
            DA: false,
            DEE: false,
            AboutMe: '',
            Password: '',
            StorePassword: '',
            Tag: [],
            CertificationsData: [],

            open: false,
            file: '',
            imagePreviewUrl: null,
            showPassword: false,
            openCertForm: false,
            openProgress: false,
            selectedUser: props.user.id,
            disabledForMore: false,
            checkUploadAvatar: false,
        };

        this.handleOpen = this.handleOpen.bind(this);
        this.handleChipClick = this.handleChipClick.bind(this);
        this.handleAddCertClick = this.handleAddCertClick.bind(this);
        this.handleAddCertClose = this.handleAddCertClose.bind(this);
        this.handleCertEditClick = this.handleCertEditClick.bind(this);
        this.handleMoreOpen = this.handleMoreOpen.bind(this);
    }

    componentDidMount() {
        this.props.dispatch(userActions.getById(this.props.user.id));
        this.props.dispatch(departmentActions.getAll());
        this.props.dispatch(userActions.getAll());
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.users.item && nextProps.users.type === 'USERS_GETBYID_SUCCESS') {
            nextProps.users.item.map(User =>
                this.setState({
                    Username: User.UserName,
                    UserAd: User.UserAd,
                    Email: User.Email,
                    DepartmentId: User.DepartmentId,
                    JobTitle: User.JobTitle ? User.JobTitle : '',
                    FirstName: User.FirstName,
                    LastName: User.LastName,
                    F: User.Certifications ? User.Certifications.F : false,
                    AA: User.Certifications ? User.Certifications.AA : false,
                    SEA: User.Certifications ? User.Certifications.SEA : false,
                    SAE: User.Certifications ? User.Certifications.SAE : false,
                    AIA: User.Certifications ? User.Certifications.AIA : false,
                    DEA: User.Certifications ? User.Certifications.DEA : false,
                    DSA: User.Certifications ? User.Certifications.DSA : false,
                    DA: User.Certifications ? User.Certifications.DA : false,
                    DEE: User.Certifications ? User.Certifications.DEE : false,
                    AboutMe: User.AboutMe !== null ? User.AboutMe : '',
                    AvatarUrlUrl: User.AvatarUrl ? User.AvatarUrl : '',
                    imagePreviewUrl: checkValue(User.AvatarUrl) ? `${config.AvatarS3BucketEndpoint}/` + User.AvatarUrl + '.png' : null,
                    IsSales: User.IsSales,
                    IsAdmin: User.IsAdmin,
                    StorePassword: User.Password,
                    Tag: User.Tag ? User.Tag : [],
                    CertificationsData: User.CertificationsData ? User.CertificationsData : [],
                    selectedUser: User.UserId,
                })
            )
        }

        if (nextProps.user && nextProps.user.type === 'LOGIN_SUCCESS') {
            this.setState({
                UserId: nextProps.user.id
            })
        }
    }

    _handleImageChange(e) {
        e.preventDefault();

        let reader = new FileReader()
        let file = e.target.files[0];

        if (file != null) {
            reader.readAsDataURL(file)
        }

        reader.onloadend = () => {
            this.setState({
                file: file,
                imagePreviewUrl: reader.result,
                checkUploadAvatar: true,
            });
        }
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleCheckedChange = name => event => {
        this.setState({ [name]: event.target.checked });
    };

    handleSave = () => {
        var now = new Date();
        const avatarMD5Url = md5(now)

        var certifications = {
            'F': this.state.F,
            'AA': this.state.AA,
            'SEA': this.state.SEA,
            'SAE': this.state.SAE,
            'AIA': this.state.AIA,
            'DEA': this.state.DEA,
            'DSA': this.state.DSA,
            'DA': this.state.DA,
            'DEE': this.state.DEE,
        };

        var inputData = {
            'UserId': this.props.user.id,
            'UserAd': this.state.UserAd,
            'UserName': this.state.Username,
            'Email': this.state.Email,
            'DepartmentId': this.state.DepartmentId,
            'JobTitle': this.state.JobTitle,
            'FirstName': this.state.FirstName,
            'LastName': this.state.LastName,
            'Certifications': JSON.parse(JSON.stringify(certifications)),
            'CertificationsData': JSON.parse(JSON.stringify(this.state.CertificationsData)),
            'AboutMe': this.state.AboutMe,
            'AvatarUrl': this.state.checkUploadAvatar ? checkValue(this.state.imagePreviewUrl) ? avatarMD5Url : '' : this.state.AvatarUrlUrl,
            'UpdatedUserId': this.props.user.id,
            'IsSales': this.state.IsSales ? this.state.IsSales : false,
            'IsAdmin': this.state.IsAdmin ? this.state.IsAdmin : false,
            'Password': this.state.Password !== '' ? md5(this.state.Password) : this.state.StorePassword,
            'Tag': JSON.stringify(this.state.Tag),
        };

        const editData = async () => {
            try {

                this.setState({
                    openProgress: true
                })

                if (this.state.checkUploadAvatar && this.state.file !== '') {
                    await Storage
                        .put('avatar/' + avatarMD5Url + '.png', this.state.file, {
                            contentType: 'image/png'
                        })
                        .then(result => {

                        })
                        .catch(err => console.log(err));
                }

                await this.props.dispatch(userActions.update({ data: inputData }));
                await this.props.dispatch(userActions.refresh());
                await this.props.dispatch(userActions.getAll());
                await alert('Update Completely!');

                await this.setState({
                    open: false,
                    openProgress: false,
                    checkUploadAvatar: false
                })

            } catch (e) {
                console.error("Problem", e)
            }
        }

        editData();
    }

    handleOpen() {
        const editData = async () => {
            try {
                await this.props.dispatch(userActions.getById(this.props.user.id))
                await this.setState({
                    open: true,
                    disabledForMore: false,
                    Password: '',
                    selectedUser: this.props.user.id,
                })
            } catch (e) {
                console.error("Problem", e)
            }
        }

        editData();
    }

    handleMoreOpen() {
        this.setState({
            disabledForMore: true,
            open: true,
        })
    }

    handleChipClick(id) {
        this.setState({
            open: false
        })

        this.props.dispatch(userActions.getById(id));
    }

    handleClose = () => {
        this.setState({
            open: false
        })
    };

    handleMultiTag = (TagData) => {
        this.setState({
            Tag: TagData
        })
    }

    handleAddCertClick = () => {
        this.setState({
            openCertForm: true,
            CertId: -1
        })
    }

    handleAddCertClose = () => {
        this.setState({
            openCertForm: false,
        })
    }

    handleCertData = (data) => {
        this.setState({
            CertificationsData: data,
            CertId: -1
        })
    }

    handleCertEditClick = (id) => {
        this.setState({
            openCertForm: true,
            CertId: id
        })
    }

    render() {
        const { classes, departments, users } = this.props;
        const { F, AA, SEA, SAE, AIA, DEA, DSA, DA, DEE, Tag } = this.state;
        // const ChipLabel = 'Employee ID - ' + this.props.user.id;
        // const userDepartmentId = this.props.user.departmentId;

        var Certs = {
            F: this.state.F,
            AA: this.state.AA,
            SEA: this.state.SEA,
            SAE: this.state.SAE,
            AIA: this.state.AIA,
            DEA: this.state.DEA,
            DSA: this.state.DSA,
            DA: this.state.DA,
            DEE: this.state.DEE,
        };

        return (
            <div>
                <Progress openProgress={this.state.openProgress} />
                <Grid container direction='row' justify='center'>
                    <Grid item sm={12} md={10} lg={8}>
                        <Card profile>
                            <div style={{
                                background: 'hsla(205, 87%, 94%, 0.1)',
                                backgroundImage: 'radial-gradient(hsla(340, 80%, 94%, 1.00) 5%, transparent 0)',
                                backgroundSize: '30px 30px'
                            }}>
                                <Tooltip title="Edit Profile" placement="bottom">
                                    <IconButton aria-label="Edit" onClick={this.handleOpen} style={{ float: 'left' }}>
                                        <EditIcon />
                                    </IconButton>
                                </Tooltip>

                                <Tooltip title="More" placement="bottom" style={{ float: 'right' }}>
                                    <div>
                                        <IconButton aria-label="More" onClick={this.handleMoreOpen} disabled={this.props.user.id === this.state.selectedUser}>
                                            <MoreHorizIcon />
                                        </IconButton>
                                    </div>
                                </Tooltip>

                                <input
                                    accept="image/png"
                                    style={{ display: 'none' }}
                                    id="outlined-button-file"
                                    type="file"
                                    onChange={(e) => this._handleImageChange(e)}
                                />

                                <CardAvatar profile>
                                    <Avatar style={{ height: '130px', width: '130px' }}
                                        alt={this.state.UserName}
                                        src={this.state.imagePreviewUrl !== null ? this.state.imagePreviewUrl : owl}
                                        imgProps={{ onError: (e) => { e.target.src = owl; } }}
                                    />
                                </CardAvatar>

                                <p style={{
                                    marginTop: '6%',
                                    color: 'white',
                                    fontSize: '1.5em',
                                    fontWeight: 500,
                                    backgroundColor: ' rgba(0,0,0,0.3)'
                                }}>
                                    {this.state.AboutMe}
                                </p>
                            </div>
                            <Grid container style={{ marginBottom: '20px' }}>
                                <Grid item sm={12} md={6} lg={6}>
                                    <CardBody profile style={{ height: '100%' }}>
                                        <Typography style={{ color: "#3C4858", paddingTop: '10px', textAlign: 'left' }} variant="h4">
                                            {this.state.Username}
                                        </Typography>
                                        <Typography className={classes.cardCategory}>
                                            {this.state.JobTitle} {users.item && users.item.JobTitle}
                                        </Typography>
                                        {
                                            departments.items && departments.items.map((option, key) => {
                                                return <Typography variant="subtitle1" style={{ textAlign: 'left', color: 'black' }} key={key}>{option.DepartmentId === this.state.DepartmentId ? option.DepartmentName : null}</Typography>
                                            })
                                        }
                                        <div style={{ position: 'relative', top: '-450px', left: '170px' }}>
                                            <Role1 Certs={Certs} />
                                        </div>
                                    </CardBody>
                                </Grid>

                                <Grid item sm={12} md={6} lg={6}>
                                    <div style={{ marginTop: '40px' }}>
                                        {this.state.F ? <img src={certifiedF} alt="..." style={{ height: '80px' }} /> : null}
                                        {this.state.AA ? <img src={certifiedAA} alt="..." style={{ height: '80px' }} /> : null}
                                        {this.state.SEA ? <img src={certifiedSEA} alt="..." style={{ height: '80px' }} /> : null}
                                        {this.state.SAE ? <img src={certifiedSAE} alt="..." style={{ height: '80px' }} /> : null}
                                        {this.state.AIA ? <img src={certifiedAIA} alt="..." style={{ height: '80px' }} /> : null}
                                        {this.state.DEA ? <img src={certifiedDEA} alt="..." style={{ height: '80px' }} /> : null}
                                        {this.state.DSA ? <img src={certifiedDSA} alt="..." style={{ height: '80px' }} /> : null}
                                        {this.state.DA ? <img src={certifiedDA} alt="..." style={{ height: '80px' }} /> : null}
                                        {this.state.DEE ? <img src={certifiedDEE} alt="..." style={{ height: '80px' }} /> : null}
                                    </div>

                                    <div style={{ flexWrap: 'wrap', marginTop: '25px' }}>
                                        {
                                            Tag && Tag[0] &&
                                            <Chip color="secondary" deleteIcon={<DoneIcon />} icon={<FavoriteIcon />} style={{ width: 'auto', marginLeft: '10px' }} variant="outlined" label={Tag[0].value} />
                                        }
                                        {
                                            Tag && Tag[1] &&
                                            <Chip color="secondary" deleteIcon={<DoneIcon />} icon={<ThumbUpIcon />} style={{ width: 'auto', marginLeft: '10px' }} variant="outlined" label={Tag[1].value} />
                                        }
                                        {
                                            Tag && Tag[2] &&
                                            <Chip color="secondary" deleteIcon={<DoneIcon />} icon={<ThumbUpIcon />} style={{ width: 'auto', marginLeft: '10px' }} variant="outlined" label={Tag[2].value} />
                                        }
                                        {
                                            Tag && Tag[3] &&
                                            <Chip color="secondary" deleteIcon={<DoneIcon />} icon={<ThumbUpIcon />} style={{ width: 'auto', marginLeft: '10px' }} variant="outlined" label={Tag[3].value} />
                                        }
                                    </div>
                                </Grid>
                            </Grid>
                        </Card>

                    </Grid>
                    <Grid container>
                        <Grid item sm={12} md={12} lg={12}>
                            <DataTableContainer handleOpenDetailModal={this.handleMoreOpen} />
                        </Grid>
                    </Grid>
                </Grid>

                <Modal
                    aria-labelledby="simple-modal-title"
                    aria-describedby="simple-modal-description"
                    open={this.state.open}
                    onClose={this.handleClose}
                    className={classes.componentBody}
                >
                    <Grid item sm={12} md={12} style={{ width: '100vh' }}>
                        <Card className={classes.profileEditPage}>
                            <CardHeader color="warning" style={{ width: '25vh' }}>
                                <div className={classes.cardTitleWhite}>Profile</div>
                                <p className={classes.cardCategoryWhite}></p>
                            </CardHeader>
                            <CardAvatar profile>
                                <Avatar style={{ height: '130px', width: '130px' }}
                                    alt={this.state.UserName}
                                    src={this.state.imagePreviewUrl !== null ? this.state.imagePreviewUrl : owl}
                                    imgProps={{ onError: (e) => { e.target.src = owl; } }}
                                />
                            </CardAvatar>

                            {!this.state.disabledForMore
                                ?
                                <CardActions>
                                    <label htmlFor="outlined-button-file" style={{ position: 'absolute', textAlign: 'center', margin: '-6% 0 0 0' }}>
                                        <Button variant="outlined" component="span" style={{ width: '15vh' }} className={classes.button}>
                                            Upload Avatar
                                        </Button>
                                    </label>
                                </CardActions>
                                : null
                            }

                            <CardBody>
                                <Grid container>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            disabled
                                            label="Company"
                                            id="company-disabled"
                                            className={classes.textField}
                                            value="CloudRiches"
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            disabled
                                            label="Username"
                                            id="username"
                                            value={this.state.Username}
                                            className={classes.textField}
                                            onChange={this.handleChange('Username')}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={6}>
                                        <TextField
                                            disabled
                                            label="Email address"
                                            id="email-address"
                                            value={this.state.Email}
                                            className={classes.textField}
                                            onChange={this.handleChange('Email')}
                                            style={{ width: '40vh' }}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            disabled={this.state.disabledForMore}
                                            label="First Name"
                                            id="first-name"
                                            value={this.state.FirstName}
                                            className={classes.textField}
                                            onChange={this.handleChange('FirstName')}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={3}>
                                        <TextField
                                            disabled={this.state.disabledForMore}
                                            label="Last Name"
                                            id="last-name"
                                            value={this.state.LastName}
                                            className={classes.textField}
                                            onChange={this.handleChange('LastName')}
                                        />
                                    </Grid>
                                    <Grid item sm={12} md={6}>
                                        <TextField
                                            disabled={this.state.disabledForMore}
                                            label="Job Title"
                                            id="job-title"
                                            value={this.state.JobTitle}
                                            className={classes.textField}
                                            onChange={this.handleChange('JobTitle')}
                                        />
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid item sm={12} md={6}>
                                        <TextField
                                            select
                                            disabled
                                            id="outlined-select-department"
                                            label="Team"
                                            className={classes.textField}
                                            value={this.state.DepartmentId}
                                            onChange={this.handleChange('DepartmentId')}
                                            SelectProps={{
                                                MenuProps: {
                                                    className: classes.menu,
                                                },
                                            }}
                                            margin="normal"
                                        >
                                            {departments.items ? departments.items.map(option => (
                                                <MenuItem key={option.DepartmentId} value={option.DepartmentId}>
                                                    {option.DepartmentName}
                                                </MenuItem>
                                            ))
                                                : []
                                            }
                                        </TextField>
                                    </Grid>
                                </Grid>

                                <Grid container>
                                    <Grid item sm={12} md={6}>
                                        <FormControl component="fieldset" className={classes.formControl} disabled={this.state.disabledForMore}>
                                            <FormLabel component="legend">Certified</FormLabel>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={F} onChange={this.handleCheckedChange('F')} value="Fundamentals" />
                                                    }
                                                    label="Azure Fundamentals"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={AA} onChange={this.handleCheckedChange('AA')} value="Administrator Associate" />
                                                    }
                                                    label="Azure Administrator Associate"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={SEA} onChange={this.handleCheckedChange('SEA')} value="Security Engineer Associate" />
                                                    }
                                                    label="Azure Security Engineer Associate"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={SAE} onChange={this.handleCheckedChange('SAE')} value="Solutions Architect Expert" />
                                                    }
                                                    label="Azure Solutions Architect Expert"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                    </Grid>
                                    <Grid item sm={12} md={6}>
                                        <FormControl component="fieldset" className={classes.formControl} disabled={this.state.disabledForMore}>
                                            <FormLabel component="legend">Specialty Certified</FormLabel>
                                            <FormGroup>
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={AIA} onChange={this.handleCheckedChange('AIA')} value="AI Engineer Associate" />
                                                    }
                                                    label="Azure AI Engineer Associate"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={DEA} onChange={this.handleCheckedChange('DEA')} value="Data Engineer Associate" />
                                                    }
                                                    label="Azure Data Engineer Associate"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={DSA} onChange={this.handleCheckedChange('DSA')} value="Data Scientist Associate" />
                                                    }
                                                    label="Azure Data Scientist Associate"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={DA} onChange={this.handleCheckedChange('DA')} value="Developer Associate" />
                                                    }
                                                    label="Azure Developer Associate"
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Checkbox checked={DEE} onChange={this.handleCheckedChange('DEE')} value="DevOps Engineer Expert" />
                                                    }
                                                    label="Azure DevOps Engineer Expert"
                                                />
                                            </FormGroup>
                                        </FormControl>
                                        <div style={{ position: 'absolute', left: '56%', top: '18vh' }}>
                                            <Role1 Certs={Certs} />
                                        </div>
                                    </Grid>
                                </Grid>

                                {/* ---------------------------------------------------------------- */}
                                <div style={{ height: '5vh' }} />
                                <FormLabel component="legend">Licenses & Certifications
                                    {
                                        !this.state.disabledForMore
                                            ?
                                            <Tooltip title="Add" placement="bottom">
                                                <IconButton onClick={(e) => this.handleAddCertClick(e)} color="inherit" >
                                                    <AddIcon />
                                                </IconButton>
                                            </Tooltip>
                                            : null
                                    }
                                </FormLabel>

                                <CertFormComponent
                                    open={this.state.openCertForm}
                                    close={this.handleAddCertClose}
                                    handleCertData={this.handleCertData}
                                    CertId={this.state.CertId}
                                    CertificationsData={this.state.CertificationsData} />
                                <List dense={false}>
                                    {
                                        this.state.CertificationsData.map((item, index) => {
                                            return (
                                                <ListItem key={index}>
                                                    <ListItemAvatar>
                                                        <Avatar>
                                                            <FolderIcon />
                                                        </Avatar>
                                                    </ListItemAvatar>
                                                    <ListItemText
                                                        style={{ width: '10vh' }}
                                                        primary={item.CertificationName}
                                                        secondary={item.IssuingOrganization}
                                                    />
                                                    {
                                                        item.CredentialUrl &&
                                                        <ListItemText
                                                            style={{ width: '10vh' }}
                                                            primary={item.CredentialId}
                                                            secondary={<a href={item.CredentialUrl} target="_blank">See Credential</a>}
                                                        />
                                                    }

                                                    {
                                                        !this.state.disabledForMore
                                                            ?
                                                            <ListItemSecondaryAction>
                                                                <Tooltip title="Edit" placement="bottom">
                                                                    <IconButton aria-label="Edit" onClick={(e) => this.handleCertEditClick(index)}>
                                                                        <EditIcon />
                                                                    </IconButton>
                                                                </Tooltip>
                                                            </ListItemSecondaryAction>
                                                            : null
                                                    }
                                                </ListItem>
                                            )
                                        })
                                    }
                                </List>
                                {/* ---------------------------------------------------------------- */}

                                <div style={{ height: '5vh' }} />
                                <FormLabel component="legend">Tag</FormLabel>
                                {!this.state.disabledForMore
                                    ?
                                    <TagsComponent handleMultiTag={this.handleMultiTag} tags={this.state.Tag} disabled={this.state.disabledForMore} />
                                    :
                                    <div>
                                        {
                                            this.state.Tag.map((item, index) =>
                                                <p
                                                    key={index}
                                                    style={{
                                                        border: '2px solid #ed3b57',
                                                        width: 'fit-content',
                                                        borderRadius: '10px',
                                                        fontSize: '1.5em',
                                                        color: '#ed3b57',
                                                        padding: '0 10px'
                                                    }}
                                                >{'# ' + item.value}</p>)
                                        }
                                    </div>
                                }

                                <div style={{ height: '5vh' }} />
                                <FormLabel component="legend">About me</FormLabel>
                                <Grid container>
                                    <div style={{ height: '6vh' }} />
                                    <Grid item sm={12} md={12}>
                                        <TextField
                                            disabled={this.state.disabledForMore}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            inputProps={{
                                                rows: 5,
                                                maxLength: 100,
                                            }}
                                            onChange={this.handleChange('AboutMe')}
                                            value={this.state.AboutMe}
                                            multiline
                                            id="outlined-full-width"
                                            label="Say something about you..."
                                            style={{ margin: 8 }}
                                            placeholder="..."
                                            fullWidth
                                            margin="normal"
                                            variant="outlined"
                                        />
                                    </Grid>
                                </Grid>
                            </CardBody>
                            <CardFooter>
                                {
                                    this.state.disabledForMore
                                        ?
                                        <Button variant="outlined" className={classes.button} onClick={this.handleClose}>
                                            Close
                                        </Button>
                                        :
                                        <Button variant="outlined" color="secondary" className={classes.button} onClick={this.handleSave}>
                                            Update Profile
                                        </Button>
                                }
                            </CardFooter>
                        </Card>
                    </Grid>
                </Modal>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { user } = state.authentication;
    const { users, departments } = state;

    return {
        user,
        users,
        departments
    };
}

App.propTypes = {
    classes: PropTypes.object.isRequired,
    users: PropTypes.object.isRequired,
};

export default compose(connect(mapStateToProps), withStyles(styles, { withTheme: true }))(App);


// WEBPACK FOOTER //
// ./src/components/Profile/App.js